/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import AccountProfile from './account-profile';
import AccountProfileView from './account-profile.view';

export * from './account-profile';
export * from './account-profile.data';
export {
    EmailAddressSectionHeadingTag,
    IAccountProfileConfig,
    IAccountProfileProps,
    IAccountProfileResources,
    IEmailAddressSectionHeadingData,
    INameSectionHeadingData,
    IPersonalizationSectionHeadingData,
    IPreferencesSectionHeadingData,
    NameSectionHeadingTag,
    PersonalizationSectionHeadingTag,
    PreferencesSectionHeadingTag } from './account-profile.props.autogenerated';
export * from './account-profile.view';
export * from './components';

export {
    AccountProfile,
    AccountProfileView
};
